import React from 'react';
import { Modal } from './Modal';
import { useTranslation } from '~/lib/hooks/useTranslation';
import { selectionStore } from '@/lib/persistence/selectionStore';
import { usePosthogCommonEvents } from '@/lib/hooks/posthog/usePosthogCommonEvents';
import { projectId } from '~/lib/persistence/useChatHistory';

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DownloadModal: React.FC<DownloadModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const { trackTemplateEvent } = usePosthogCommonEvents();

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="w-full px-4 max-w-[400px]">
        <div className="bg-dualite-background-tertiary rounded-lg border border-dualite-border-secondary shadow-2xl relative w-full overflow-hidden flex flex-col">
          {/* Header */}
          <div className="p-4 border-b border-dualite-border-secondary flex justify-between items-center bg-dualite-background-tertiary shrink-0">
            <h3 className="text-dualite-text-primary font-medium text-sm">
              {t('modals.downloadModal.title', 'Download as ZIP')}
            </h3>
            <button
              onClick={onClose}
              className="text-dualite-text-secondary hover:text-dualite-text-primary transition-colors ml-2"
            >
              <div className="i-ph:x-bold text-sm" />
            </button>
          </div>

          <div className="p-4">
            <p className="text-dualite-text-secondary text-xs leading-relaxed">
              {t('modals.downloadModal.message', 'Are you sure you want to download the project as a ZIP file?')}
            </p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onClose();
                }}
                className="px-3 py-2 text-dualite-text-secondary hover:text-dualite-text-primary bg-transparent border border-dualite-border-secondary hover:border-dualite-border-primary rounded-md transition-colors text-xs font-medium"
              >
                {t('modals.downloadModal.cancel', 'Cancel')}
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onConfirm();
                  trackTemplateEvent('downloaded', {
                    project_id: projectId.get() ?? undefined,
                    template_id: selectionStore.get().templateId,
                    template_name: selectionStore.get().templateName,
                  });
                }}
                className="px-3 py-2 bg-dualite-background-cta text-dualite-text-cta hover:bg-dualite-background-cta-hover rounded-md text-xs font-medium transition-colors"
              >
                {t('modals.downloadModal.download', 'Download')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
